// Модели агента: каталог из Claude Code и выбор владельца (api: /api/models).
import {
  effortLabel,
  type ModelCatalog,
  type ModelChoice,
  type ModelInfo,
  type ModelSettings,
  modelLabel,
} from '@autoaff/protocol';
import { useQuery } from '@tanstack/react-query';
import { api } from './api';

export interface ModelsState {
  catalog: ModelCatalog | null;
  settings: ModelSettings;
  runner: boolean;
}

export function useModels() {
  return useQuery({
    queryKey: ['models'],
    queryFn: () => api<ModelsState>('/api/models'),
    staleTime: 5 * 60_000,
  });
}

export function findModel(catalog: ModelCatalog | null | undefined, id: string): ModelInfo | undefined {
  return catalog?.models.find((m) => m.id === id);
}

/** «Opus 5.5» и «высокая» — для кнопки выбора. */
export function choiceParts(
  choice: ModelChoice,
  catalog?: ModelCatalog | null,
): { model: string; effort: string | null } {
  const m = findModel(catalog, choice.model);
  return {
    model: m?.label ?? modelLabel(choice.model),
    effort: choice.effort ? effortLabel(choice.effort).toLowerCase() : null,
  };
}

export function choiceText(choice: ModelChoice, catalog?: ModelCatalog | null): string {
  const p = choiceParts(choice, catalog);
  return p.effort ? `${p.model} · ${p.effort}` : p.model;
}
